/** XML autorizado do documento (nfeProc), em texto, não em Base64. */
export class GerarPdfPorXmlRequest {
  xml = '';
}
